/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

import { handleActions } from 'redux-actions';
import produce from 'immer';
import * as types from '@src/store/types';

const initialState = {
  otherUserProfileStates: {},
  otherUserProfile: {},
};

export default handleActions(
  {
    [types.GET_OTHER_USER_PROFILE_CALL](state, { payload }) {
      return produce(state, (draft) => {
        draft.otherUserProfileStates[payload.user_id] = 'LOADING';
      });
    },
    [types.GET_OTHER_USER_PROFILE_DONE](state, { payload }) {
      return produce(state, (draft) => {
        draft.otherUserProfileStates[payload.user_id] = 'SUCCESS';
        draft.otherUserProfile = payload.response;
      });
    },
    [types.GET_OTHER_USER_PROFILE_FAIL](state, { payload }) {
      return produce(state, (draft) => {
        draft.otherUserProfileStates[payload.user_id] = 'FAIL';
      });
    },
  },
  initialState
);
